import { useT } from '../../i18n';

export interface RedirectScreenProps {
  gatewayName: string;
  checkoutUrl: string;
  onCancel: () => void;
  redirectCountdown: number | null;
}

export function RedirectScreen({
  gatewayName,
  checkoutUrl,
  onCancel,
  redirectCountdown,
}: RedirectScreenProps) {
  const t = useT();
  return (
    <div
      className="flex flex-col items-center justify-center px-8 py-12 text-center flex-1"
      style={{ background: 'var(--t-redirect-bg)', color: '#ffffff' }}
    >
      {/* Security badge */}
      <div
        className="flex items-center gap-1.5 px-3 py-1.5 mb-6"
        style={{ background: 'rgba(255,255,255,0.2)', borderRadius: 'var(--t-pill-radius)' }}
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M6 1L2 3v3c0 2.5 1.7 4.8 4 5.5 2.3-.7 4-3 4-5.5V3L6 1z" fill="#22c55e" />
          <path d="M5 6.5l1 1 2-2.5" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <span className="text-[11px] font-medium">{t('redirect.secureBadge')}</span>
      </div>

      <h3 className="text-[20px] font-semibold mb-2">{t('redirect.title')}</h3>
      <p className="text-[14px] mb-2 opacity-90">
        {t('redirect.description', { gateway: gatewayName })}
      </p>
      {redirectCountdown !== null && (
        <p className="text-[13px] mb-6 opacity-70">
          {t('redirect.countdown', { seconds: String(redirectCountdown) })}
        </p>
      )}

      <a
        href={checkoutUrl}
        className="w-full font-medium text-[16px] flex items-center justify-center gap-2 transition-all"
        style={{
          height: 52,
          borderRadius: 'var(--t-cta-radius)',
          background: '#ffffff',
          color: '#000000',
          textDecoration: 'none',
        }}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('redirect.openTab')}
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M4 1.5h8.5V10M12 2L2 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </a>

      <p className="text-[11px] mt-2 opacity-60">
        {t('redirect.tabHelper')}
      </p>

      <button
        className="w-full font-medium text-[14px] mt-2 transition-all"
        style={{
          height: 48,
          borderRadius: 'var(--t-cta-radius)',
          background: 'rgba(255,255,255,0.2)',
          color: '#ffffff',
        }}
        onClick={onCancel}
      >
        {t('redirect.cancel')}
      </button>
    </div>
  );
}
